<template>
  <div class="event-item-container">
    <div class="table-section">
      <div class="table-header">
        <h3>Gyerekek listája</h3>
        <span class="count-badge">{{ groups?.length }} gyerek</span>
      </div>
      
      <div class="modern-table-container">
        <table class="modern-table">
          <thead>
            <tr>
              <th>
                <div class="th-content">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
                    <circle cx="12" cy="7" r="4"/>
                  </svg>
                  Diák neve
                </div>
              </th>
              <th>
                <div class="th-content">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M9 12l2 2 4-4"/>
                    <path d="M21 12c-1 0-3-1-3-3s2-3 3-3 3 1 3 3-2 3-3 3"/>
                  </svg>
                  Visszajelzés
                </div>
              </th>
              <th>
                <div class="th-content">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <circle cx="12" cy="12" r="10"/>
                    <polyline points="12,6 12,12 16,14"/>
                  </svg>
                  Egyenleg
                </div>
              </th>
              <th>
                <div class="th-content">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M21 12V7H5a2 2 0 0 1 0-4h14v4"/>
                    <path d="M3 5v14a2 2 0 0 0 2 2h16v-5"/>
                    <path d="M18 12a2 2 0 0 0 0 4h4v-4z"/>
                  </svg>
                  Fizetés
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(child, index) in groups" :key="index" class="table-row">
              <td class="name-cell">
                <div class="cell-content">
                  <div class="child-icon">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
                      <circle cx="12" cy="7" r="4"/>
                    </svg>
                  </div>
                  <div class="child-info">
                    <span class="child-name">{{ child.child_name }}</span>
                  <button 
                    v-if="(isAdmin || isTeacher)"
                    class="payment-action-btn"
                    @click="openPaymentModal(child)"
                    title="Egyenleg feltöltése"
                  >
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <path d="M21 12V7H5a2 2 0 0 1 0-4h14v4"/>
                      <path d="M3 5v14a2 2 0 0 0 2 2h16v-5"/>
                      <path d="M18 12a2 2 0 0 0 0 4h4v-4z"/>
                    </svg>
                    Feltöltés
                  </button>
                  </div>
                </div>
              </td>
              <td class="response-cell">
                <span class="response-badge" :class="getResponseClass(child.resp)">{{ child.resp }}</span>
              </td>
              <td class="balance-cell">
                <div class="balance-pill" :class="{ 'balance-debt': child.wallet_balance < 0, 'balance-ok': child.wallet_balance >= 0 }">
                  {{ formatPrice(child.wallet_balance) }}
                </div>
              </td>
              <td class="payment-cell">
                <div class="payment-status">
                  <div v-if="child.has_paid" class="payment-indicator payment-paid">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <path d="M9 12l2 2 4-4"/>
                      <path d="M21 12c-1 0-3-1-3-3s2-3 3-3 3 1 3 3-2 3-3 3"/>
                    </svg>
                    <span>Fizetve</span>
                  </div>
                  <div v-else-if="child.amount_due > 0" class="payment-indicator payment-pending">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <circle cx="12" cy="12" r="10"/>
                      <polyline points="12,6 12,12 16,14"/>
                    </svg>
                    <span>{{ child.amount_due }} Ft</span>
                  </div>
                  <div v-else class="payment-indicator payment-unknown">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <circle cx="12" cy="12" r="10"/>
                      <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/>
                      <path d="M12 17h.01"/>
                    </svg>
                    <span>Nem ismert</span>
                  </div>
                </div>
                <div class="ticket-info">
                  <router-link :to="`/children/${child.child_id}/billing`" class="billing-link">
                    Fizetési részletek
                  </router-link>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <div class="event-actions">
    <div v-if="remTime.rem_day == 0 && remTime.rem_hour <= 5">
      <div v-if="groups">
        <button 
          v-if="(groups[0].status.String == '5' || groups[0].status.String == '6')" 
          class="modern-btn modern-btn--primary" 
          @click="event_end()"
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M9 12l2 2 4-4"/>
            <path d="M21 12c-1 0-3-1-3-3s2-3 3-3 3 1 3 3-2 3-3 3"/>
          </svg>
          Alkalom vége
        </button>
        <div v-else class="alert alert-warning">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
            <line x1="12" y1="9" x2="12" y2="13"/>
            <line x1="12" y1="17" x2="12.01" y2="17"/>
          </svg>
          A foglalkozás már le lett zárva.
        </div>
      </div>
    </div>
  </div>

  <!-- Popup for Event End -->
  <teleport to="body">
    <div v-if="showChildPopup" class="mdl-overlay" @click.self="closeChildPopup">
      <div class="mdl">
        <div class="mdl__header">
          <h3>Hogyan érezted magad?</h3>
          <button class="mdl__close" @click="closeChildPopup">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <line x1="18" y1="6" x2="6" y2="18"/>
              <line x1="6" y1="6" x2="18" y2="18"/>
            </svg>
          </button>
        </div>
        
        <div class="mdl__body">
          <div class="modern-table-container">
            <table class="modern-table">
              <thead>
                <tr>
                  <th>
                    <div class="th-content">
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
                        <circle cx="12" cy="7" r="4"/>
                      </svg>
                      Diák neve
                    </div>
                  </th>
                  <th>
                    <div class="th-content">
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <path d="M9 12l2 2 4-4"/>
                        <path d="M21 12c-1 0-3-1-3-3s2-3 3-3 3 1 3 3-2 3-3 3"/>
                      </svg>
                      Értékelés
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(child, index) in filteredGroups" :key="index" class="table-row">
                  <td class="name-cell">
                    <div class="cell-content">
                      <div class="child-icon">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                          <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
                          <circle cx="12" cy="7" r="4"/>
                        </svg>
                      </div>
                      <span class="child-name">{{ child.child_name }}</span>
                    </div>
                  </td>
                  <td class="action-cell">
                    <button v-if="child.evnt_grd === undefined"
                            class="modern-btn modern-btn--outline"
                            @click="handleChildClick(child)">
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <path d="M9 12l2 2 4-4"/>
                        <path d="M21 12c-1 0-3-1-3-3s2-3 3-3 3 1 3 3-2 3-3 3"/>
                      </svg>
                      Értékelés
                    </button>
                    <span v-else class="grade-badge">{{ child.evnt_grd }}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="form-section">
            <h4>Házi feladat</h4>
            <textarea v-model="homework"
            class="modern-textarea"
            placeholder="Házifeladat a diáköknek"
            ></textarea>
          </div>
          <div class="form-section">
            <h4>Megjegyzés</h4>
            <textarea v-model="notes"
            class="modern-textarea"
            placeholder="Megjegyzés az órával kapcsolatban, mi történt stb. stb."
            ></textarea>
          </div>
        </div>
        
        <div class="mdl__footer">
          <button class="modern-btn modern-btn--secondary" @click="closeChildPopup">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <line x1="18" y1="6" x2="6" y2="18"/>
              <line x1="6" y1="6" x2="18" y2="18"/>
            </svg>
            Bezárás
          </button>
          <button class="modern-btn modern-btn--success" @click="saveEventEnd(groups[0].evnt_id)">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"/>
              <polyline points="17,21 17,13 7,13 7,21"/>
              <polyline points="7,3 7,8 15,8"/>
            </svg>
            Mentés
          </button>
        </div>
      </div>
    </div>
  </teleport>

  <!-- Popup for Child Actions (4 buttons) -->
  <teleport to="body">
    <div v-if="showChildActionsPopup" class="mdl-overlay" @click.self="closeChildActionsPopup">
      <div class="mdl">
        <div class="mdl__header">
          <h3>Hogyan érezted ma magad <strong>{{ selectedChild?.child_name }}</strong>?</h3>
          <button class="mdl__close" @click="closeChildActionsPopup">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <line x1="18" y1="6" x2="6" y2="18"/>
              <line x1="6" y1="6" x2="18" y2="18"/>
            </svg>
          </button>
        </div>
        
        <div class="mdl__body">
          <div class="action-buttons">
            <button class="action-btn action-btn--good" @click="handleAction('action1', selectedChild.child_id, selectedChild.evnt_id)">
              <span class="emoji">😊</span>
              <span>Jól</span>
            </button>
            <button class="action-btn action-btn--okay" @click="handleAction('action2', selectedChild.child_id, selectedChild.evnt_id)">
              <span class="emoji">😐</span>
              <span>Meh</span>
            </button>
            <button class="action-btn action-btn--bad" @click="handleAction('action3', selectedChild.child_id, selectedChild.evnt_id)">
              <span class="emoji">😢</span>
              <span>Nem jól</span>
            </button>
          </div>
        </div>
        
        <div class="mdl__footer">
          <button class="modern-btn modern-btn--secondary" @click="handleAction('action4', selectedChild.child_id, selectedChild.evnt_id)">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M9 12l2 2 4-4"/>
              <path d="M21 12c-1 0-3-1-3-3s2-3 3-3 3 1 3 3-2 3-3 3"/>
            </svg>
            Nem volt jelen
          </button>
          <button class="modern-btn modern-btn--danger" @click="closeChildActionsPopup">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M19 14l-7 7m0 0l-7-7m7 7V3"/>
            </svg>
            Vissza
          </button>
        </div>
      </div>
    </div>
  </teleport>

  <!-- Wallet top-up Modal -->
  <teleport to="body">
    <div v-if="showPaymentModal" class="mdl-overlay" @click="closePaymentModal">
      <div class="mdl-content" @click.stop>
        <div class="mdl__header">
          <h3>Egyenleg feltöltése</h3>
          <button @click="closePaymentModal" class="mdl__close">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <line x1="18" y1="6" x2="6" y2="18"/>
              <line x1="6" y1="6" x2="18" y2="18"/>
            </svg>
          </button>
        </div>
        <div class="mdl__body">
          <div class="child-info-modal">
            <h4>Feltöltés a következő gyerekhez:</h4>
            <p><strong>{{ getSelectedChildName() }}</strong></p>
            <p>Jelenlegi egyenleg: <strong>{{ formatPrice(selectedChild ? selectedChild.wallet_balance : 0) }}</strong></p>
          </div>
          <form @submit.prevent="saveTopUp">
            <div class="form-group">
              <label for="topUpAmount">Feltöltött összeg (Ft):</label>
              <input
                id="topUpAmount"
                v-model.number="paymentForm.amount"
                type="number"
                step="1"
                min="1"
                required
                placeholder="0"
              />
            </div>

            <div class="form-group">
              <label for="paymentMethod">Fizetési mód:</label>
              <select id="paymentMethod" v-model="paymentForm.method" required>
                <option value="készpénz">Készpénz</option>
                <option value="bankkártya">Bankkártya</option>
                <option value="átutalás">Átutalás</option>
                <option value="egyéb">Egyéb</option>
              </select>
            </div>

            <div class="form-group">
              <label for="paymentNotes">Megjegyzés:</label>
              <textarea
                id="paymentNotes"
                v-model="paymentForm.notes"
                placeholder="Fizetésről szóló megjegyzés..."
              ></textarea>
            </div>

            <div class="mdl__footer">
              <button type="button" @click="closePaymentModal" class="modern-btn modern-btn--secondary">Mégse</button>
              <button type="submit" class="modern-btn modern-btn--success" :disabled="saving">
                {{ saving ? 'Mentés...' : 'Feltöltés' }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </teleport>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      groups: null,
      resp_enum: {
        0: "Nem jelzett",
        10: "Jön",
        11: "Megérkezett",
        20: "Nem jön"
      },
      showChildPopup: false,
      showChildActionsPopup: false,
      selectedChild: null,
      grd_enum: {
        10: "Jól",
        20: "Meh",
        30: "Nem jól",
        40: "Nem volt jelen"
      },
      notes: ``,
      homework: ``,
      isAdmin: false,
      isTeacher: false,
      // Wallet top-up modal state
      showPaymentModal: false,
      paymentForm: {
        child_id: null,
        amount: 0,
        method: 'készpénz',
        notes: ''
      },
      saving: false
    };
  },
  computed: {
    filteredGroups() {
      return this.groups.filter(child => child.response.Int64 !== 20);
    }
  },
  props: {
    eventDate: {
      type: String,
      required: true
    },
    groupId: {
      type: Number,
      required: true
    },
    remTime: {
      type: Object,
      required: true
    }
  },
  methods: {
    getIsAdmin() {
      this.isAdmin = this.$isAdmin();
    },
    getIsTeacher() {
      this.isTeacher = this.$isTeacher();
    },
    getResponseClass(response) {
      if (response === "Jön" || response === "Megérkezett") {
        return "response-badge--positive";
      } else if (response === "Nem jön") {
        return "response-badge--negative";
      } else {
        return "response-badge--neutral";
      }
    },
    initiatePayment(child) {
      this.selectedChild = child;
      this.showPaymentPopup = true;
    },
    closePaymentPopup() {
      this.showPaymentPopup = false;
      this.selectedChild = null;
    },
    async getGroupEvents() {
      try {
        const response = await axios.post(this.$BACKEND_HOST + '/api/groupevent', {
          event_grp_id: this.groupId,
          set_date: this.eventDate
        });
        if (response.data.message === "done") {
          this.groups = response.data.groups;
          if (this.groups !== null) {
            this.groups.forEach(grp => {
              grp.resp = this.resp_enum[grp.response.Int64];
              grp.evnt_grd = this.grd_enum[grp.attended.Int64];
            });
          }
        }
      } catch (error) {
        console.error('Error updating item:', error);
      }
    },

    event_end() {
      if (this.groups && this.groups.length > 0) {
        console.log('Opening popup - showChildPopup:', this.showChildPopup);
        this.showChildPopup = true;
        console.log('After setting - showChildPopup:', this.showChildPopup);
      }
    },

    closeChildPopup() {
      this.showChildPopup = false;
    },

    handleChildClick(child) {
      this.selectedChild = child;
      this.showChildPopup = false;
      this.showChildActionsPopup = true;
    },

    closeChildActionsPopup() {
      this.showChildActionsPopup = false;
      this.showChildPopup = true;
    },
    async sendPost(status, childId, eventId) {
      try {
          const payload = {
            status: status,
            child_id: childId,
            evnt_id  : eventId,
            set_date : '',
          };
          
          const response = await axios.post(this.$BACKEND_HOST + '/api/child/eventgrade', payload);

        } catch (error) {
          console.error('Error marking attendance:', error);
        }
    },
    handleAction(actionType, childId, evntId) {
      let grp = this.groups.find(g => g.child_id == childId)
      var evnt_grd;
      switch (actionType) {
        case 'action1':
          evnt_grd = 10;
          break;
        case 'action2':
          evnt_grd = 20;
          break;
        case 'action3':
          evnt_grd = 30;
          break;
        case 'action4':
          evnt_grd = 40;
          break;
        default:
          break;
      }
      grp.evnt_grd = this.grd_enum[evnt_grd];
      this.sendPost(evnt_grd,childId,evntId);
      
      this.closeChildActionsPopup();
    },
    async saveEventEnd(eventId) {
      try {
          const payload = {
            event_id: eventId,
            notes:  this.notes,
            homework  : this.homework,
          };
          console.log(payload);
          const response = await axios.post(this.$BACKEND_HOST + '/api/updatevenetend', payload);
          if(response.data.message == "done") {
            await this.getGroupEvents();
            this.showChildPopup = false;
            this.showChildActionsPopup = false;
          }
        } catch (error) {
          console.error('Error marking attendance:', error);
        }
    },

    // Wallet top-up modal methods
    openPaymentModal(child) {
      this.selectedChild = child;
      this.paymentForm = {
        child_id: child.child_id,
        amount: 0,
        method: 'készpénz',
        notes: ''
      };
      this.showPaymentModal = true;
    },

    closePaymentModal() {
      this.showPaymentModal = false;
      this.selectedChild = null;
      this.paymentForm = {
        child_id: null,
        amount: 0,
        method: 'készpénz',
        notes: ''
      };
    },

    async saveTopUp() {
      this.saving = true;
      try {
        await axios.post(this.$BACKEND_HOST + '/api/billing/wallet/topup', {
          child_id: this.selectedChild.child_id,
          amount: parseFloat(this.paymentForm.amount),
          method: this.paymentForm.method,
          note: this.paymentForm.notes
        });
        this.closePaymentModal();
        await this.getGroupEvents(); // Refresh balances
        alert('Egyenleg sikeresen feltöltve!');
      } catch (error) {
        console.error('Error topping up wallet:', error);
        alert('Hiba történt a feltöltés során');
      }
      this.saving = false;
    },

    getSelectedChildName() {
      return this.selectedChild ? this.selectedChild.child_name : 'Ismeretlen gyerek';
    },

    formatPrice(price) {
      if (price === undefined || price === null || isNaN(price)) {
        return '0 Ft';
      }
      const numPrice = typeof price === 'string' ? parseFloat(price) : price;
      if (isNaN(numPrice)) {
        return '0 Ft';
      }
      return new Intl.NumberFormat('hu-HU', {
        style: 'currency',
        currency: 'HUF'
      }).format(numPrice);
    },
  },
  watch: {
    eventDate(newValue, oldValue) {
      this.getGroupEvents();
    }
  },
  mounted() {
    this.getGroupEvents();
    this.getIsAdmin();
    this.getIsTeacher();
  }
};
</script>

<style scoped>
.event-item-container {
  padding: 1rem;
}

.table-section {
  background: var(--card-bg);
  border-radius: 16px;
  box-shadow: var(--shadow-sm);
  overflow: hidden;
  margin-bottom: 1.5rem;
}

.table-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem 2rem;
  border-bottom: 1px solid var(--color-border);
  background: var(--bg-secondary);
}

.table-header h3 {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 600;
  color: var(--color-text);
}

.count-badge {
  background: var(--button-primary);
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 20px;
  font-size: 0.875rem;
  font-weight: 600;
}

.modern-table-container {
  overflow-x: auto;
}

.modern-table {
  width: 100%;
  border-collapse: collapse;
}

.modern-table th {
  background: var(--bg-secondary);
  padding: 1rem 1.5rem;
  text-align: left;
  font-weight: 600;
  color: var(--color-text);
  border-bottom: 1px solid var(--color-border);
  position: sticky;
  top: 0;
  z-index: 10;
}

.th-content {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.th-content svg {
  color: var(--primary-blue);
}

.table-row {
  transition: all 0.2s ease;
}

.table-row:hover {
  background: var(--hover-bg);
}

.table-row td {
  padding: 1rem 1.5rem;
  border-bottom: 1px solid var(--color-border);
  vertical-align: middle;
}

.name-cell {
  font-weight: 500;
}

.cell-content {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.child-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  background: var(--button-primary);
  border-radius: 8px;
  color: white;
  flex-shrink: 0;
}

.child-name {
  color: var(--color-text);
  font-weight: 500;
}

.child-info {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  align-items: flex-start;
}

.payment-action-btn {
  display: flex;
  align-items: center;
  gap: 0.375rem;
  padding: 0.375rem 0.75rem;
  background: var(--warning);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 0.75rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.payment-action-btn:hover {
  background: #d97706;
  transform: translateY(-1px);
}

.response-cell {
  text-align: center;
}

.response-badge {
  display: inline-block;
  padding: 0.375rem 0.75rem;
  border-radius: 12px;
  font-size: 0.875rem;
  font-weight: 500;
}

.response-badge--positive {
  background: var(--success);
  color: white;
}

.response-badge--negative {
  background: var(--error);
  color: white;
}

.response-badge--neutral {
  background: var(--warning);
  color: white;
}

.balance-cell {
  text-align: center;
}

.balance-pill {
  display: inline-block;
  padding: 0.375rem 0.75rem;
  border-radius: 12px;
  font-size: 0.875rem;
  font-weight: 600;
  white-space: nowrap;
}

.balance-ok {
  background: var(--success);
  color: white;
}

.balance-debt {
  background: var(--error);
  color: white;
}

.payment-cell {
  text-align: center;
  vertical-align: middle;
}

.payment-status {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
}

.payment-indicator {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.375rem 0.75rem;
  border-radius: 12px;
  font-size: 0.875rem;
  font-weight: 500;
  white-space: nowrap;
}

.payment-paid {
  background: var(--success);
  color: white;
}

.payment-pending {
  background: var(--warning);
  color: white;
}

.payment-unknown {
  background: var(--color-border);
  color: var(--color-text-muted);
}

.payment-indicator svg {
  flex-shrink: 0;
}

.ticket-info {
  font-size: 0.75rem;
  color: var(--color-text-muted);
  font-style: italic;
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.billing-link {
  color: var(--primary-blue);
  text-decoration: none;
  font-style: normal;
}

.billing-link:hover {
  text-decoration: underline;
}

.event-actions {
  display: flex;
  justify-content: center;
  margin-top: 1.5rem;
}

.modern-btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  text-decoration: none;
}

.modern-btn--primary {
  background: var(--button-primary);
  color: white;
}

.modern-btn--primary:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-lg);
}

.modern-btn--secondary {
  background: var(--card-bg);
  color: var(--color-text);
  border: 2px solid var(--color-border);
}

.modern-btn--secondary:hover {
  background: var(--hover-bg);
  border-color: var(--primary-blue);
  color: var(--primary-blue);
}

.modern-btn--success {
  background: var(--success);
  color: white;
}

.modern-btn--success:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-lg);
}

.modern-btn--danger {
  background: var(--error);
  color: white;
}

.modern-btn--danger:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-lg);
}

.modern-btn--outline {
  background: transparent;
  color: var(--primary-blue);
  border: 2px solid var(--primary-blue);
}

.modern-btn--outline:hover {
  background: var(--primary-blue);
  color: white;
}

.alert {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 1rem 1.5rem;
  border-radius: 12px;
  font-weight: 500;
}

.alert-warning {
  background: var(--warning);
  color: white;
}

.mdl-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.7) !important;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9000 !important;
  backdrop-filter: blur(4px);
  overflow-y: auto;
  padding: 20px;
}

.mdl {
  background: var(--card-bg, #ffffff);
  border-radius: 16px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  max-width: 600px;
  width: 90%;
  max-height: 90vh;
  overflow-y: auto;
  z-index: 10000;
}

.mdl__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem 2rem;
  border-bottom: 1px solid var(--color-border);
  background: var(--bg-secondary);
}

.mdl__header h3 {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 600;
  color: var(--color-text);
}

.mdl__close {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  background: transparent;
  border: none;
  border-radius: 8px;
  color: var(--color-text-muted);
  cursor: pointer;
  transition: all 0.2s ease;
}

.mdl__close:hover {
  background: var(--hover-bg);
  color: var(--color-text);
}

.mdl__body {
  padding: 2rem;
}

.mdl__footer {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  padding: 1.5rem 2rem;
  border-top: 1px solid var(--color-border);
  background: var(--bg-secondary);
}

.form-section {
  margin-bottom: 1.5rem;
}

.form-section h4 {
  margin: 0 0 0.75rem 0;
  font-size: 1rem;
/* Ticket selection styles */
.ticket-selection {
  margin-bottom: 2rem;
}

.ticket-selection h4 {
  margin: 0 0 1rem 0;
  font-size: 1.125rem;
  font-weight: 600;
  color: var(--color-text);
}

.ticket-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1rem;
}

.ticket-option {
  padding: 1.5rem;
  background: var(--color-background-mute);
  border: 2px solid var(--color-border);
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.ticket-option:hover {
  border-color: var(--primary-blue);
  background: var(--primary-blue-bg);
}

.ticket-option.selected {
  border-color: var(--primary-blue);
  background: var(--primary-blue-bg);
}

.ticket-name {
  font-weight: 600;
  font-size: 1rem;
  color: var(--color-text);
  margin-bottom: 0.5rem;
}

.ticket-type {
  font-size: 0.875rem;
  color: var(--color-text-muted);
  margin-bottom: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.ticket-price {
  font-size: 1.125rem;
  font-weight: 700;
  color: var(--primary-blue);
}

@media (max-width: 768px) {
  .ticket-grid {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
  
  .ticket-option {
    padding: 1rem;
  }
}
  font-weight: 600;
  color: var(--color-text);
}

.modern-textarea {
  width: 100%;
  padding: 0.875rem 1rem;
  border: 2px solid var(--color-border);
  border-radius: 12px;
  background: var(--card-bg);
  color: var(--color-text);
  font-size: 1rem;
  transition: all 0.2s ease;
  resize: vertical;
  min-height: 100px;
}

.modern-textarea:focus {
  outline: none;
  border-color: var(--primary-blue);
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.modern-textarea::placeholder {
  color: var(--text-muted);
}

.action-cell {
  text-align: center;
}

.grade-badge {
  display: inline-block;
  background: var(--success);
  color: white;
  padding: 0.375rem 0.75rem;
  border-radius: 12px;
  font-size: 0.875rem;
  font-weight: 500;
}

.action-buttons {
  display: flex;
  justify-content: center;
  gap: 1.5rem;
  margin: 2rem 0;
  flex-wrap: wrap;
}

.action-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.75rem;
  padding: 1.5rem 2rem;
  border: none;
  border-radius: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 120px;
}

.action-btn--good {
  background: var(--success);
  color: white;
}

.action-btn--okay {
  background: var(--warning);
  color: white;
}

.action-btn--bad {
  background: var(--error);
  color: white;
}

.action-btn:hover {
  transform: translateY(-4px);
  box-shadow: var(--shadow-lg);
}

.emoji {
  font-size: 2rem;
}

@media (max-width: 768px) {
  .event-item-container {
    padding: 0.75rem;
  }

  .table-header {
    padding: 1rem 1.5rem;
  }

  .modern-table th,
  .table-row td {
    padding: 0.75rem 1rem;
  }

  .mdl {
    width: 95%;
    margin: 1rem;
  }

  .mdl__header,
  .mdl__body,
  .mdl__footer {
    padding: 1rem 1.5rem;
  }

  .mdl__footer {
    flex-direction: column;
  }

  .modern-btn {
    width: 100%;
    justify-content: center;
  }

  .action-buttons {
    flex-direction: column;
    align-items: center;
  }
  .action-btn {
    width: 100%;
    max-width: 200px;
  }
  
  .payment-status {
    gap: 0.25rem;
  }
  
  .payment-indicator {
    padding: 0.25rem 0.5rem;
    font-size: 0.75rem;
  }
  
  .ticket-info {
    max-width: 100px;
    font-size: 0.7rem;
  }
  
  .pass-ticket-relation {
    font-size: 0.65rem;
  }
  
  .pass-ticket-info {
    font-size: 0.65rem;
  }
}

/* Payment modal specific styles */
.mdl-content {
  background: var(--card-bg);
  border-radius: 16px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  max-width: 500px;
  width: 90%;
  max-height: 90vh;
  overflow-y: auto;
  z-index: 10000;
}

.child-info-modal {
  background: var(--color-background-mute);
  padding: 1rem;
  border-radius: 8px;
  margin-bottom: 1.5rem;
  border: 1px solid var(--color-border);
}

.child-info-modal h4 {
  color: var(--color-heading);
  margin: 0 0 0.5rem 0;
  font-size: 1.1rem;
}

.child-info-modal p {
  margin: 0;
  color: var(--color-text);
}

.form-group {
  margin-bottom: 1.5rem;
}

.form-group label {
  display: block;
  margin-bottom: 0.5rem;
  color: var(--color-heading);
  font-weight: 500;
}

.form-group input,
.form-group textarea,
.form-group select {
  width: 100%;
  padding: 0.75rem;
  border: 1px solid var(--color-border);
  border-radius: 8px;
  background: var(--color-background);
  color: var(--color-text);
  font-size: 1rem;
}

.form-group textarea {
  resize: vertical;
  min-height: 80px;
}

@media (max-width: 768px) {
  .mdl-content {
    width: 95%;
    margin: 1rem;
  }
}
</style>
